<template>
  <div class='safe-section'>
    <div class="new-title">
      <div class="sec-new-title">
        <span class='title'>天气情况</span>
      </div>
      <div class="tabHistory">
        <img
          class="lastWeek"
          @click="lastWeekWeather"
          :style="weatherSlot=='history'?{opacity:0.5}:{opacity:1}"
          src="@/assets/images/airDataBoard/lastweek.png"/>
        <img
          class="thisWeek"
          @click="thisWeekWeather"
          :style="weatherSlot=='now'?{opacity:0.5}:{opacity:1}"
          src="@/assets/images/airDataBoard/thisweek.png"/>
      </div>
    </div>
    <div class='sec-content' style="padding:0;">
      <weatherSafety setNum="1" :weatherSlot = weatherSlot></weatherSafety>
    </div>
    <div class="sec-title">
      <span class='title'>事故统计</span>
    </div>
    <div class='sec-content seamless-warp'>
      <vue-seamless-scroll :data="scrollSafetyData" class="seamless-warp" :class-option="classOption">
        <div class='con-column' v-for="(item,index) in scrollSafetyData" :key="index">
          <img
            class="con-img"
            :src=item.imgName />
          <div class='con-num'>{{item.typeNum}}</div>
          <div class='con-txt'>{{item.typeName}}</div>
        </div>
      </vue-seamless-scroll>
    </div>
    <div class="sec-title">
      <span class='title'>绿色施工</span>
    </div>
    <div class='sec-content'>
      <div class='con-column'>
         <img
          class="con-img"
          src="@/assets/images/airDataBoard/carClear.png"/>
        <div class='con-num'>{{quality_vihiclecleaning}}</div>
        <div class='con-txt'>车辆清洗(次)</div>
      </div>
      <div class='con-column'>
         <img
          class="con-img"
          src="@/assets/images/airDataBoard/green.png"/>
        <div class='con-num'>{{quality_area}}</div>
        <div class='con-txt'>场地苫盖(㎡)</div>
      </div>
      <div class='con-column'>
         <img
          class="con-img"
          src="@/assets/images/airDataBoard/clear.png"/>
        <div class='con-num'>{{quality_spray}}</div>
        <div class='con-txt'>降尘喷洒次数(次)</div>
      </div>
    </div>
    <div class="sec-title title-bottom">
      <span class='title'>疫情防控</span>
    </div>
    <div class='label-content'>
      <div class="public-bg font-size-16 in-case font-FFFFFF-50">
        <p>
          <span>当日通风消杀</span>
          实际：
          <i class="f2899FF padd10">
            {{epidemicData.daxing_actualdisinfection}}
          </i>  
          计划：
          <i class="f2899FF padd10">
            {{epidemicData.daxing_plandisinfection}}
          </i> (次)
        </p>
        <p>
          <span>今日体温检测</span>
          合格：
          <i class="f2899FF padd10">
            {{epidemicData.daxing_checktemperature}}
          </i>   
          检测：
          <i class="f2899FF padd10">
            {{epidemicData.daxing_checkperson}}
          </i> (人)
        </p>
         <p>
          <span>本周核酸检测</span>
          合格：
          <i class="f2899FF padd10">
            {{epidemicData.daxing_checkthisweek}}
          </i>   
          检测：
          <i class="f2899FF padd10">
            {{epidemicData.daxing_checkpeople}}
          </i> (人)
        </p>
      </div>
    </div>
  </div>
</template>
<script type="text/javascript">
import vueSeamlessScroll from 'vue-seamless-scroll'
import weatherSafety from '../common/weatherSafety'
export default {
  name: 'SafeCulture', // 商机状态
  components: {
    weatherSafety,
    vueSeamlessScroll
  },
  props: {
  },
  data () {
    return {
      options: [],
      scrollSafetyData:[],
      quality_vihiclecleaning: '',  // 车辆清洗
      quality_area: '',  //场地苫盖
      quality_spray: '',  //降尘喷洒次数
      buildNow: [], // 危险源识别--当前施工阶段
      epidemicData: {},
      weatherSlot:'now'
    }
  },
  computed: {
  
    classOption () {
      return {
        step: 0.2, // 数值越大速度滚动越快
        limitMoveNum:4, // 开始无缝滚动的数据量 this.dataList.length
        hoverStop: true, // 是否开启鼠标悬停stop
        direction:2, // 0向下 1向上 2向左 3向右
        openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 1000 // 单步运动停止的时间(默认值1000ms)
      }
    }
  }, 
  mounted () {
    this.getScrollSafetyData();
    this.safetytimer = setInterval(() => {
      this.getScrollSafetyData()
    }, 5000)
  },
  methods: {
    getScrollSafetyData(){
      let _this = this;
      let url = `${window.pubilc_config.webserverurl}/api/Daxing/Daxing/`
      
      _this.$axios
        .get(url+'Getsavety')
        .then(res=>{
          if (res.status == 200) {
            let res_data = res.data;
            
            _this.scrollSafetyData = [
            {
              imgName: require('@/assets/images/airDataBoard/safetyImageIcon/quality_srike.png'),
              typeNum: res_data.quality_srike,
              typeName: '物体打击'
            },
            {
              imgName: require('@/assets/images/airDataBoard/safetyImageIcon/quality_fire.png'),
              typeNum: res_data.quality_fire,
              typeName: '火灾'
            },
            {
              imgName: require('@/assets/images/airDataBoard/safetyImageIcon/quality_dke.png'),
              typeNum: res_data.quality_dke,
              typeName: '中毒和窒息'
            },
            {
              imgName: require('@/assets/images/airDataBoard/safetyImageIcon/quality_mechianical.png'),
              typeNum: res_data.quality_mechianical,
              typeName: '机械伤害'
            },
            {
              imgName: require('@/assets/images/airDataBoard/safetyImageIcon/quality_vehicleinjury.png'),
              typeNum: res_data.quality_vehicleinjury,
              typeName: '车辆伤害'
            },
            {
              imgName: require('@/assets/images/airDataBoard/safetyImageIcon/quality_craneinjury.png'),
              typeNum: res_data.quality_craneinjury,
              typeName: '起重伤害'
            },
            {
              imgName: require('@/assets/images/airDataBoard/safetyImageIcon/quality_electricshock.png'),
              typeNum: res_data.quality_electricshock,
              typeName: '触电'
            },
            {
              imgName: require('@/assets/images/airDataBoard/safetyImageIcon/quality_burn.png'),
              typeNum: res_data.quality_burn,
              typeName: '灼伤'
            },
            {
              imgName: require('@/assets/images/airDataBoard/safetyImageIcon/quality_skydiving.png'),
              typeNum: res_data.quality_skydiving,
              typeName: '高空坠落'
            },
            {
              imgName: require('@/assets/images/airDataBoard/safetyImageIcon/quality_collapse.png'),
              typeNum: res_data.quality_collapse,
              typeName: '坍塌'
            },
            {
              imgName: require('@/assets/images/airDataBoard/safetyImageIcon/quality_gunpowder.png'),
              typeNum: res_data.quality_gunpowder,
              typeName: '火药爆炸'
            },
            {
              imgName: require('@/assets/images/airDataBoard/safetyImageIcon/quality_otherdanger.png'),
              typeNum: res_data.quality_otherdanger,
              typeName: '其他伤害'
            },

          ]
          }
        }).catch(err=>{
          console.log(err,'===api/Daxing/Daxing/Getquality')
        })
      _this.$axios
        .get(url+'Getgreen')
        .then(res=>{
          if (res.status == 200) {
            // console.log(res.data);
            let _g_data = res.data;
            _this.quality_vihiclecleaning = _g_data.daxing_cleancar;  // 车辆清洗
            _this.quality_area = _g_data.daxing_place;  //场地苫盖
            _this.quality_spray = _g_data.daxing_spraying;  //降尘喷洒次数
          }
        }).catch(err=>{
          console.log(err,'===api/Daxing/Daxing/Getgreen')
        })
      _this.$axios
        .get(url+'Getepidemic')
        .then(res=>{
          if (res.status == 200) {
            _this.epidemicData = res.data;
            
          }
        }).catch(err=>{
          console.log(err,'===api/Daxing/Daxing/Getepidemic')
        })
    },
    thisWeekWeather(){
      if(this.weatherSlot == 'now'){
        return
      }else{
        this.weatherSlot = 'now'
      }
    },
    lastWeekWeather(){
      if(this.weatherSlot == 'history'){
        return
      }else{
        this.weatherSlot = 'history'
      }
    }
  },
  destroyed () {
    clearTimeout(this.safetytimer)
  }
}
</script>
<style lang="less" scoped>
.safe-section{
  margin:20px 20px 0;
  // padding-bottom: 0;
  .sec-title.title-bg-120{
    width: 120px;
    
    background: url('../../assets/images/title_board_120.png') no-repeat;
    background-size: cover;
  }
  .new-title{
      height: 50px;
    .sec-new-title{
      float: left;  
      margin-top: 11px;
      width: 100px;
      height: 36px;
      background: url('../../assets/images/airDataBoard/title_board.png') no-repeat;
      background-size: cover;
      display: flex;
      align-items: center;
      justify-content: center;
      .title{
        font-size: 18px;
        font-family: SourceHanSansCN;
        color: #26ABFF;
        font-weight: 550;
      }
    }
    .tabHistory{
      float: right;
      margin: 16px 20px 0 0;
      width: 70px;
      .lastWeek{
        float: left;
        width: 30px;
        height: 30px;
        cursor: pointer;
      }
      .thisWeek{
        float: right;
        width: 30px;
        height: 30px;
        cursor: pointer;
      }
    }
  }
  .sec-title.title-bottom{
    margin-bottom: 10px;
  }
  .sec-title{
    margin-top: 11px;
    width: 100px;
    height: 36px;
    background: url('../../assets/images/airDataBoard/title_board.png') no-repeat;
    background-size: cover;
    display: flex;
    align-items: center;
    justify-content: center;
    .title{
      font-size: 18px;
      font-family: SourceHanSansCN;
      color: #26ABFF;
      font-weight: 550;
    }
  }
  .seamless-warp{
    width: 415px;
    overflow-x: auto;
    padding: 9px 20px !important;
    white-space: nowrap;
    .con-column{
      width: 90px;
      text-align: center;
      display: inline-block;

      .con-img{
        width: 28px;
        height: 28px;
      }
      .con-bgimg{
        width: 28px;
        height: 28px;
      }
      .con-num{
        font-size: 20px;
        font-family: AlibabaPuHuiTi;
        font-weight: 400;
        color: #FFFFFF;
      }
      .con-txt{
        font-size: 14px;
        font-family: SourceHanSansCN;
        font-weight: 500;
        color: #FFFFFF;
        opacity: 0.5;
      }
    }
  }
  .sec-content{
    background: linear-gradient(rgba(7, 17, 41, 0.8), rgba(19, 31, 54, 0.8));
    border-radius: 2px;
    padding: 16px 0 14px;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    text-align: center;
    .con-column{
      .con-img{
        width: 28px;
        height: 28px;
        margin-bottom: 9px;
      }
      .con-num{
        font-size: 20px;
        font-family: AlibabaPuHuiTi;
        font-weight: 400;
        color: #FFFFFF;
      }
      .con-txt{
        font-size: 14px;
        font-family: SourceHanSansCN;
        font-weight: 500;
        color: #FFFFFF;
        opacity: 0.5;
      }
    }
    
    
  }
  .label-content{
    background: linear-gradient(rgba(7, 17, 41, 0.8), rgba(19, 31, 54, 0.8));
    border-radius: 2px;
    display: flex;
    padding: 10px 0 5px 28px;
    flex-direction: column;
    .phase-txt{
      width: 100%;
      font-size: 14px;
      font-family: SourceHanSansCN;
      font-weight: 550;
      color: #2D91FF;
    }
    .labels{
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      .label-sec{
        width: 60px;
        height: 25px;
        line-height:25px;
        text-align: center;
        background: #B35417;
        border-radius: 1px;
        font-size: 12px;
        font-family: SourceHanSansCN;
        font-weight: 500;
        color: #FFFFFF;
        margin-right: 26px;
        margin-top: 20px;
      }
    }
  }
}
.in-case {
    p {
      line-height: 34px;
      span {
        padding-right: 25px;
      }
      .padd10{
        font-family: 'AlibabaPuHuiTi-Regular';
        display: inline-block;
        margin-right: 10px;
        min-width: 29px;
      }
      .padd5{
        width: 10px;
      }
    }
  }
  ::-webkit-scrollbar {
    width: 0px;
    height: 0px;
  }
</style>

